<script setup>
import { computed, ref } from "vue";
import { useTagStore } from "@/stores/useTagStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const tagStore = useTagStore();

const selectedCount = computed(() => tagStore.selectedTagIds.length);

// Congela ao abrir para a mensagem não mudar durante o delete
const frozenCount = ref(selectedCount.value);
if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;

function buildBatchTagDeleteError(error) {
  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "";

  let userFriendlyMessage =
    "Ocorreu um erro ao tentar excluir as tags em lote.";

  if (raw) userFriendlyMessage = raw;

  const looksLikeFK =
    raw.includes("foreign key constraint fails") ||
    raw.toLowerCase().includes("constraint") ||
    raw.toLowerCase().includes("foreign key");

  if (looksLikeFK) {
    userFriendlyMessage =
      "Uma ou mais tags de nota selecionadas estão vinculadas a Notas e não podem ser removidas.\nPara excluí-las, remova primeiro todas as notas associadas a estas tags de nota.";
  }

  return userFriendlyMessage;
}

const messageTitle = computed(() => {
  if (frozenCount.value === 1) {
    return "Tem certeza que deseja excluir esta tag de nota?";
  }

  return `Tem certeza que deseja excluir ${frozenCount.value} tags de nota?`;
});

const successMessage = computed(() => {
  if (frozenCount.value === 1) {
    return "Tag de nota apagada com sucesso.";
  }

  return `${frozenCount.value} tags de nota apagadas com sucesso.`;
});

async function onConfirmBatchDelete() {
  try {
    await tagStore.deleteSelectedTags();

    tagStore.shouldForcePageOne = true;
    tagStore.selectedTagIds = [];

    emit("notify", {
      type: "success",
      message: successMessage.value,
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildBatchTagDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Tags de Nota em Lote"
    :messageTitle="messageTitle"
    messageSubtitle="Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmBatchDelete"
    @close="emit('close')"
  />
</template>